<template>
  <el-form class="whole">
    <el-container direction="vertical" class="rect">
      <div style="margin-top: 50px">
        <img src="https://website-1252117456.cos.ap-chengdu.myqcloud.com/img/logo/logo_400.png" style="width: 200px;height: 134px">
      </div>

      <h1 style="display: inline;margin-top: 80px">404页面没有找到哇╮（╯＿╰）╭</h1>

    </el-container>
  </el-form>
</template>

<script>
    import jsCookie from 'js-cookie'

    export default {
        name: "NotFound",
        data() {
            return {
                name: '',
                password: ''
            }
        },
        methods: {
            login() {
                this.baseJs.postWithMsg('HardwareLogin', {
                    theName: this.name,
                    password: this.password
                }, obj => {
                    console.log('登录成功')
                    jsCookie.set('name',this.name)
                    this.$router.push('BackEnd/ProvinceList')
                },true,undefined,false)
            }
        }
    }
</script>

<style scoped>
  .rect {
    width: 50%;
    height: 60%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
  }

  .whole {
    width: 100%;
    height: 100%;
    text-align: center;
    position: relative;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }

  .inputDiv {
    padding-top: 30px;
    padding-left: 50px;
    padding-right: 50px;
    padding-bottom: 30px;
    text-align: left;
  }

  .input {
    margin-top: 20px;
  }

  .loginBtn {
    display: block;
    margin: 0 auto;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/404.vue